import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contractType", "decimalsField", "erc1155IndexField"]

  connect() {
    // Set initial state based on current contract type value
    if (this.hasContractTypeTarget) {
      this.handleContractTypeChange()
    }
  }

  handleContractTypeChange() {
    if (this.hasDecimalsFieldTarget) {
      this.decimalsFieldTarget.required = this.contractTypeTarget.value === 'erc20'
    }
    
    if (this.hasErc1155IndexFieldTarget) {
      this.erc1155IndexFieldTarget.required = this.contractTypeTarget.value === 'erc1155'
    }
  }
} 